import React, { useState } from 'react';
import {
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Checkbox,
    Typography,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    CardContent,
    CardHeader,
    Card,
    CardMedia,
    Button,
    Container
} from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {CMAContext} from "./CMAContext";
import {useHistory} from "react-router-dom";
import {ContactsContext} from "./ContactsContext";
import {useReports} from "./ReportContext";
import Breadcrumb from "./BreadcrumbsComponent";
import IconButton from "@material-ui/core/IconButton";
import {consoleDevLog} from "../apiConfig";

const NewSmartReport = (props) => {
    const homes = [
  {
    id: 1,
    lat: 43.70,
    lng: -79.42,
    address: '123 Lake Shore',
    mls: 'MLS1',
    municipality: 'Toronto',
    price: 500000,
    status: 'active',
    date: '2023-01-01',
    score: 85,
    distance: 0.2,
    bedroom: 2,
    bathroom: 2,
    bathroomsPlus: 1,
    lotSize: 2000,
    squareFeet: 1200,
    image: '../src/assets/images/home1.jpg',
    adjustedPrice: null,
    suggestedPriceAdjustments: [
      {amount: -10000, description: "No backyard pool", selected: false},
      {amount: 15000, description: "Renovated kitchen", selected: false},
      {amount: -15000, description: "Outdated bathroom", selected: false}
    ]
  },
  {
    id: 2,
    lat: 43.71,
    lng: -79.43,
    address: '456 Queen St',
    mls: 'MLS2',
    municipality: 'Toronto',
    price: 650000,
    status: 'sold',
    date: '2023-02-15',
    score: 95,
    distance: 0.5,
    bedroom: 3,
    bathroom: 3,
    bathroomsPlus: 2,
    lotSize: 2500,
    squareFeet: 1500,
    image: '../src/assets/images/home2.jpg',
    adjustedPrice: null,
    suggestedPriceAdjustments: [
      {amount: -20000, description: "Old HVAC system", selected: false},
      {amount: 10000, description: "New hardwood floors", selected: false},
      {amount: 15000, description: "High-end appliances", selected: false}
    ]
  },
  {
    id: 3,
    lat: 43.72,
    lng: -79.44,
    address: '789 King St',
    mls: 'MLS3',
    municipality: 'Toronto',
    price: 700000,
    status: 'pending',
    date: '2023-03-10',
    score: 90,
    distance: 0.3,
    bedroom: 2,
    bathroom: 2,
    bathroomsPlus: 1,
    lotSize: 2200,
    squareFeet: 1300,
    image: '../src/assets/images/home3.jpg',
    adjustedPrice: null,
    suggestedPriceAdjustments: [
      {amount: -15000, description: "No garage", selected: false},
      {amount: 20000, description: "Large backyard", selected: false},
      {amount: -10000, description: "Needs roof repair", selected: false}
    ]
  },
  {
    id: 4,
    lat: 43.73,
    lng: -79.45,
    address: '321 Yonge St',
    mls: 'MLS4',
    municipality: 'Toronto',
    price: 800000,
    status: 'active',
    date: '2023-03-20',
    score: 88,
    distance: 0.4,
    bedroom: 3,
    bathroom: 3,
    bathroomsPlus: 2,
    lotSize: 2600,
    squareFeet: 1400,
    image: '../src/assets/images/home4.jpg',
    adjustedPrice: null,
    suggestedPriceAdjustments: [
      {amount: -25000, description: "High traffic area", selected: false},
      {amount: 20000, description: "Close to park", selected: false},
      {amount: -20000, description: "Poor insulation", selected: false}
    ]
  },
  {
    id: 5,
    lat: 43.74,
    lng: -79.46,
    address: '654 Bloor St',
    mls: 'MLS5',
    municipality: 'Toronto',
    price: 600000,
    status: 'sold',
    date: '2023-03-30',
    score: 92,
    distance: 0.6,
    bedroom: 2,
    bathroom: 2,
    bathroomsPlus: 1,
    lotSize: 2100,
    squareFeet: 1250,
    image: '../src/assets/images/home5.jpg',
    adjustedPrice: null,
    suggestedPriceAdjustments: [
      {amount: 15000, description: "Recently painted", selected: false},
      {amount: -20000, description: "Old windows", selected: false},
      {amount: 20000, description: "New plumbing", selected: false}
    ]
  }
];
    const history = useHistory();
    const { contacts } = React.useContext(ContactsContext);  // Destructure contacts from context

    // Check if a client has been passed in the history state
    const initialState = props.location && props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null;

    // Initialize the selectedClient and selectedPreferences with passed values (or null if none are passed)
    const [selectedClient, setSelectedClient] = useState(initialState ? `${initialState.firstName} ${initialState.lastName}` : null);
    const [selectedPreferences, setSelectedPreferences] = useState(initialState ? initialState.preferences : {});

    const { cmas, addCMA} = React.useContext(CMAContext);
    consoleDevLog("cmas in new smart report:", cmas);

    const [selectedHome, setSelectedHome] = useState(null);
    const [areaAnalysis, setAreaAnalysis] = useState({
        demographics: false,
        crimeData: false,
        schools: false,
        costOfLiving: false,
        employment: false,
        recreation: false,
        infrastructure: false
    });
    const [selectedCMAs, setSelectedCMAs] = useState([]);

    consoleDevLog(selectedClient);
    const clientCMAs = cmas.filter(cma => cma.client === selectedClient);
    const homeDetails = selectedHome;

    const handleCMASelection = (cmaName) => {
        if (selectedCMAs.includes(cmaName)) {
            setSelectedCMAs(prev => prev.filter(name => name !== cmaName));
        } else {
            setSelectedCMAs(prev => [...prev, cmaName]);
        }
    };

    const { addReport } = useReports();

    const handlePublish = () => {
        consoleDevLog(selectedHome);
        const newReport = {
            image: '../src/assets/images/CMA_or_Report_1.png',
            title: "Seller Report",
            client: selectedClient,
            preferences: selectedPreferences,
            home: selectedHome,
            // ... any other necessary details
        };
        addReport(newReport);
    };

    return (
        <Container>
        <Grid container spacing={3}>
            <Breadcrumb />

            <Grid item xs={12}>
                <Typography variant="h4" className="new-report-header">Create Seller Report</Typography>
            </Grid>

            {/* The Button Grid is here */}
            <Grid container spacing={2} justifyContent="center" className="buttons" style={{marginLeft: "5px", marginRight: "5px"}}>
                <Grid item xs={12} sm={4}>
                    <Button
                        variant="contained"
                        color="default"
                        fullWidth
                        style={{
                            // borderRadius: '25px',
                            fontSize: '16px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: '#1976d2', // Darker shade for hover
                                boxShadow: '2px 2px 5px rgba(0,0,0,0.2)'
                            }
                        }}
                        onClick={() => history.push('/smart-reports/new-smart-report/preview')}
                    >
                        Preview
                    </Button>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        style={{
                            // borderRadius: '25px',
                            backgroundColor: '#f57070',
                            fontSize: '16px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: '#e64a4a', // Darker shade for hover
                                boxShadow: '2px 2px 5px rgba(0,0,0,0.2)'
                            }
                        }}
                        // onClick={/* Autogenerate Functionality */}
                    >
                        Autogenerate
                    </Button>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{
                            // borderRadius: '25px',
                            fontSize: '16px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.08)', // Slight shade for hover
                                boxShadow: '2px 2px 5px rgba(0,0,0,0.2)'
                            }
                        }}
                        onClick={handlePublish}
                    >
                        Publish
                    </Button>
                </Grid>
            </Grid>


            <Grid item xs={12}>
                <Accordion className="accordion-root">
                    <AccordionSummary
                        expandIcon={
                            <IconButton
                                style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.05)', // Default lighter shade
                                    borderRadius: '50%'
                                }}
                                className="custom-icon-button" // Add a class for hover effect
                            >
                                <ExpandMoreIcon style={{ color: '#333' }} />
                            </IconButton>
                        }
                        aria-controls="home-of-interest-content"
                        id="home-of-interest-header"
                        className="accordion-header"
                    >
                        <div>
                            <Typography variant="h5">Home of Interest</Typography>
                            {/* Here's your sub-header */}
                            <Typography variant="subtitle1" style={{ opacity: 0.7 }}>Choose and view home details.</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-details">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    label="Select Home"
                                    value={selectedHome ? selectedHome.id : ''}
                                    onChange={(e) => {
                                        const homeObj = homes.find(home => home.id === parseInt(e.target.value));
                                        setSelectedHome(homeObj);
                                    }}
                                    fullWidth
                                >
                                    {homes.map((home) => (
                                        <MenuItem key={home.id} value={home.id}>
                                            {home.address}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            {homeDetails && (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <img src={homeDetails.image} alt={homeDetails.address} className="home-image" />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="body1"><strong>Address:</strong> {homeDetails.address}</Typography>
                                        <Typography variant="body1"><strong>MLS:</strong> {homeDetails.mls}</Typography>
                                        <Typography variant="body1"><strong>Municipality:</strong> {homeDetails.municipality}</Typography>
                                        <Typography variant="body1"><strong>Price:</strong> ${homeDetails.price}</Typography>
                                        <Typography variant="body1"><strong>Status:</strong> {homeDetails.status}</Typography>
                                        {/* ... Add more details as necessary */}
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </AccordionDetails>
                </Accordion>

            </Grid>

            <Grid item xs={12}>
                <Accordion className="accordion-root">
                    <AccordionSummary
                        expandIcon={
                            <IconButton
                                style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.05)', // Default lighter shade
                                    borderRadius: '50%'
                                }}
                                className="custom-icon-button"
                            >
                                <ExpandMoreIcon style={{ color: '#333' }} />
                            </IconButton>
                        }
                        aria-controls="client-specifications-content"
                        id="client-specifications-header"
                        className="accordion-header"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">Client Specifications</Typography>
                            <Typography variant="subtitle1" style={{ opacity: 0.7 }}>Set client preference details.</Typography>
                        </div>

                    </AccordionSummary>
                <AccordionDetails className="accordion-details">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>Select Client</InputLabel>
                                <Select
                                    value={selectedClient}
                                    onChange={(e) => {
                                        const clientName = e.target.value;
                                        const client = contacts.find(contact => `${contact.firstName} ${contact.lastName}` === clientName);
                                        setSelectedClient(clientName);
                                        setSelectedPreferences(client.preferences);
                                    }}
                                >
                                    {contacts.map(contact => (
                                        <MenuItem key={contact.email} value={`${contact.firstName} ${contact.lastName}`}>
                                            {contact.firstName} {contact.lastName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {selectedClient && (
                            <>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Min Budget ($)"
                                        type="number"
                                        value={selectedPreferences.budget ? selectedPreferences.budget.min : ''}
                                        onChange={(e) => setSelectedPreferences(prev => ({ ...prev, budget: { ...prev.budget, min: e.target.value }}))}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Max Budget ($)"
                                        type="number"
                                        value={selectedPreferences.budget ? selectedPreferences.budget.max : ''}
                                        onChange={(e) => setSelectedPreferences(prev => ({ ...prev, budget: { ...prev.budget, max: e.target.value }}))}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Description"
                                        multiline
                                        minRows={4}
                                        value={selectedPreferences.description || ''}
                                        onChange={(e) => setSelectedPreferences(prev => ({ ...prev, description: e.target.value }))}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Desired Property Size (sqft)"
                                        type="number"
                                        value={selectedPreferences.propertySize || ''}
                                        onChange={(e) => setSelectedPreferences(prev => ({ ...prev, propertySize: e.target.value }))}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.parkingRequired || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, parkingRequired: e.target.checked }))}
                                            />
                                        }
                                        label="Parking Required"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.nearTransportation || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, nearTransportation: e.target.checked }))}
                                            />
                                        }
                                        label="Near Transportation"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.schoolsNearby || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, schoolsNearby: e.target.checked }))}
                                            />
                                        }
                                        label="Schools Nearby"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.petsAllowed || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, petsAllowed: e.target.checked }))}
                                            />
                                        }
                                        label="Pets Allowed"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.outdoorSpace || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, outdoorSpace: e.target.checked }))}
                                            />
                                        }
                                        label="Outdoor Space"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.amenities || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, amenities: e.target.checked }))}
                                            />
                                        }
                                        label="Amenities"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.neighborhoodSafety || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, neighborhoodSafety: e.target.checked }))}
                                            />
                                        }
                                        label="Neighborhood Safety"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.shoppingProximity || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, shoppingProximity: e.target.checked }))}
                                            />
                                        }
                                        label="Shopping Proximity"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedPreferences.quietArea || false}
                                                onChange={(e) => setSelectedPreferences(prev => ({ ...prev, quietArea: e.target.checked }))}
                                            />
                                        }
                                        label="Quiet Area"
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
            <Grid item xs={12}>
                <Accordion className="accordion-root">
                    <AccordionSummary
                        expandIcon={
                            <IconButton
                                style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.05)', // Default lighter shade
                                    borderRadius: '50%'
                                }}
                                className="custom-icon-button"
                            >
                                <ExpandMoreIcon style={{ color: '#333' }} />
                            </IconButton>
                        }
                        aria-controls="smart-cmas-content"
                        id="smart-cmas-header"
                        className="accordion-header"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">Smart CMAs</Typography>
                            <Typography variant="subtitle1" style={{ opacity: 0.7 }}>Generate market analyses.</Typography>
                        </div>

                    </AccordionSummary>
    <AccordionDetails className="accordion-details">
        <Grid container spacing={3}>
            {clientCMAs.map(cma => (
                <Grid item xs={12} md={6} key={cma.cmaName}>
                    <Card
                        className={`cma-card ${selectedCMAs.includes(cma.cmaName) ? 'selected' : ''}`}
                        onClick={() => {
                            if (selectedCMAs.includes(cma.cmaName)) {
                                setSelectedCMAs(prev => prev.filter(name => name !== cma.cmaName));
                            } else {
                                setSelectedCMAs(prev => [...prev, cma.cmaName]);
                            }
                        }}
                    >
                        <Grid container>
                            <Grid item xs={5}>
                                <CardMedia
                                    component="img"
                                    alt="House Image"
                                    height="140"
                                    image={cma.subjectProperty.image}
                                    title="House Image"
                                    className="cma-image"
                                />
                            </Grid>
                            <Grid item xs={7} className="cma-content">
                                <Typography variant="h5">{cma.cmaName}</Typography>
                                <Typography variant="body2">{cma.subjectProperty.address}</Typography>
                                <Typography variant="body2">Client: {cma.client}</Typography>
                                <Typography variant="body2">Price Range: ${cma.priceRange.lower} - ${cma.priceRange.upper}</Typography>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            ))}
        </Grid>
    </AccordionDetails>
                </Accordion>
            </Grid>

            <Grid item xs={12}>
                <Accordion className="accordion-root">
                    <AccordionSummary
                        expandIcon={
                            <IconButton
                                style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.05)', // Default lighter shade
                                    borderRadius: '50%'
                                }}
                                className="custom-icon-button"
                            >
                                <ExpandMoreIcon style={{ color: '#333' }} />
                            </IconButton>
                        }
                        aria-controls="area-analysis-content"
                        id="area-analysis-header"
                        className="accordion-header"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">Area Analysis and Demographics</Typography>
                            <Typography variant="subtitle1" style={{ opacity: 0.7 }}>Explore local insights.</Typography>
                        </div>

                    </AccordionSummary>
                <AccordionDetails className="accordion-details">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined" className="info-card">
                                <CardHeader title="Essentials" className="card-header"/>
                                <CardContent>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={areaAnalysis.demographics}
                                                onChange={(e) => setAreaAnalysis(prev => ({ ...prev, demographics: e.target.checked }))}
                                            />
                                        }
                                        label="Demographics"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={areaAnalysis.crimeData}
                                                onChange={(e) => setAreaAnalysis(prev => ({ ...prev, crimeData: e.target.checked }))}
                                            />
                                        }
                                        label="Crime"
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined" className="info-card">
                                <CardHeader title="Lifestyle" className="card-header"/>
                                <CardContent>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={areaAnalysis.schools}
                                                onChange={(e) => setAreaAnalysis(prev => ({ ...prev, schools: e.target.checked }))}
                                            />
                                        }
                                        label="Schools"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={areaAnalysis.costOfLiving}
                                                onChange={(e) => setAreaAnalysis(prev => ({ ...prev, costOfLiving: e.target.checked }))}
                                            />
                                        }
                                        label="Cost of Living"
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined" className="info-card">
                                <CardHeader title="Employment" className="card-header"/>
                                <CardContent>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={areaAnalysis.employment}
                                                onChange={(e) => setAreaAnalysis(prev => ({ ...prev, employment: e.target.checked }))}
                                            />
                                        }
                                        label="Employment and Economy"
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined" className="info-card">
                                <CardHeader title="Facilities" className="card-header"/>
                                <CardContent>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={areaAnalysis.recreation}
                                                onChange={(e) => setAreaAnalysis(prev => ({ ...prev, recreation: e.target.checked }))}
                                            />
                                        }
                                        label="Recreation and Activities"
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </AccordionDetails>
                </Accordion>
            </Grid>



            <Grid item xs={12}>
                <Accordion className="accordion-root">
                    <AccordionSummary
                        expandIcon={
                            <IconButton
                                style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.05)', // Default lighter shade
                                    borderRadius: '50%'
                                }}
                                className="custom-icon-button"
                            >
                                <ExpandMoreIcon style={{ color: '#333' }} />
                            </IconButton>
                        }
                        aria-controls="price-analysis-explanation-content"
                        id="price-analysis-explanation-header"
                        className="accordion-header"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">Price Analysis Explanation</Typography>
                            <Typography variant="subtitle1" style={{ opacity: 0.7 }}>Understand pricing factors.</Typography>
                        </div>

                    </AccordionSummary>
    <AccordionDetails className="accordion-details">
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            // checked={/* You should link this to a state variable for tracking */}
                            onChange={(e) => {/* Update the state variable here */}}
                        />
                    }
                    label="Include Compatibility Scores"
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            // checked={/* You should link this to another state variable for tracking */}
                            onChange={(e) => {/* Update the state variable here */}}
                        />
                    }
                    label="Include Price Analysis Explanation"
                />
            </Grid>
        </Grid>
    </AccordionDetails>
</Accordion>
                </Grid>


            {/* Add other accordions wrapped in a Grid item xs={12} like above. */}
        </Grid>
            </Container>
    );
}

export default NewSmartReport;
